export const steps = [
    {
        title: 'Run risk assessment',
        description:
            'To conduct a risk assessment, click the aforementioned button, choose the asset type you wish to evaluate, complete the fields below, and then submit.',
    },
];
